import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { IceCream2, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sc-blue flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-[2rem] p-9 sm:p-11 shadow-[0_20px_60px_rgba(44,42,40,0.18)] border-4 border-white">
        <Link to="/" className="flex items-center gap-2.5 justify-center mb-8">
          <span className="grid place-items-center w-12 h-12 rounded-full bg-sc-espresso text-sc-cream">
            <IceCream2 size={24} strokeWidth={1.6} />
          </span>
        </Link>
        <div className="text-center">
          <div className="eyebrow mb-2">Santa Chiara</div>
          <h1 className="font-serif-display text-3xl text-sc-espresso">Admin Dashboard</h1>
          <p className="mt-2 text-sm text-sc-espresso/60">Sign in to manage the gelato cart.</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="w-full bg-transparent border-b border-sc-espresso/20 py-2.5 text-sc-espresso focus:outline-none focus:border-sc-gold transition-colors"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="w-full bg-transparent border-b border-sc-espresso/20 py-2.5 text-sc-espresso focus:outline-none focus:border-sc-gold transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-sc-espresso text-sc-cream font-medium hover:bg-sc-gold transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"} <ArrowRight size={18} />
          </button>
        </form>
        <Link to="/" className="block text-center mt-6 text-sm text-sc-espresso/60 hover:text-sc-espresso">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
